import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import Navigation from '../components/Navigation';

const PrivateRoute = ({ component: Component, loggedIn, ...rest }) => (
  <Route
    {...rest}
    render={props => (localStorage.getItem('token') ? (
      <Navigation content={Component} />
    ) : (
      <Redirect
        to={{
          pathname: '/login',
          state: { from: props.location },
        }}
      />
    ))
    }
  />
);

export default PrivateRoute;
